<div class="toolbar-header header centered-layout" *transloco="let t; read: 'HEADER_COMPONENT'">
  <a routerLink="/" class="logo" *ngIf="currentSite$ | async as currentSite">
    <app-logo></app-logo>
  </a>

  <div class="spacer"></div>
  <app-reload-button *ngIf="userWithCashRegister$ | async" [link]="['/reload']" [showReloadTextWithoutWarning]="!!(showReloadTextInHeader$ | async)">
  </app-reload-button>

  <!-- MOBILE -->
  <div class="ml-8 account-button-container hide-if-desktop">
    @if (activeAccountNavBarItem$ | async; as activeAccountNavBarItem) {
      @if (!activeAccountNavBarItem.isOnNavBar) {
        <app-navbar-item [hideText]="true" [item]="activeAccountNavBarItem" size="large"></app-navbar-item>
      }
    }
  </div>
  <!-- DESKTOP-->
  <div class="account-button-container-desktop hide-if-mobile">
    <app-badge class="force-small" *ngIf="accountNavBarItemNotif$ | async as accountNotif" [count]="accountNotif.count"> </app-badge>
    <ion-button (click)="openMenu($event)" fill="clear" class="rounded account-button">
      <ion-icon name="menu"></ion-icon>
      <ion-icon name="person-circle"></ion-icon>
    </ion-button>
  </div>
</div>
